export default "__VITE_ASSET__Bl_k0tuf__"